appHost.actions.register({
    // #region Vars
    name: '288a.commerce.cart.delete',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tCart = data;
        if (tCart == null) {
            return this.Cancel();
        }
        let tArgs = {
            title: appHost.localizer.t('client.Commerce.Carts.Title') + " " + tCart.cartNumber,
            message: appHost.localizer.t('client.Commerce.Carts.DeleteQuestion'),
            successCallback: async () => {
                //Delete
                await this.$appHost.api.delete(`commerce/carts/${tCart.cartID}`);
                //Store
                this.$store.commit('carts/load');
            }
        };
        return this.Window(await appHost.notification.showModal2("g-messages-question", tArgs));
    },
    // #endregion
});
export {};
